module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/earth-532ca4cfcc951ee1ed9d08868e369144.svg";